var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v(" "+_vm._s(_vm.$t('common.releaseNotes.title'))+" ")]),_c('v-card-text',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }